import { useState } from 'react';
import helpContentData from '@/assets/help/help-content.json';
import type { HelpContent, HelpSection, HelpItem, HelpDocument } from '@/assets/help/help-content.types';

export function useHelpContent() {
  const [helpContent] = useState<HelpContent>(helpContentData);

  // Get section by ID
  const getSection = (sectionId: string): HelpSection | undefined => {
    return helpContent.sections.find(section => section.id === sectionId);
  };

  // Get item by ID
  const getItem = (sectionId: string, itemId: string): HelpItem | undefined => {
    const section = getSection(sectionId);
    return section?.items.find(item => item.id === itemId);
  };

  // Get all sections
  const getAllSections = (): HelpSection[] => {
    return Object.values(helpContent.sections);
  };

  const getDocuments = (): HelpDocument[] => {
    return helpContent.documents ?? [];
  };

  return {
    helpContent,
    getSection,
    getItem,
    getAllSections,
    getDocuments
  };
}
